/**
 * Shows Instant Shop ad, provided that the user has placed at least 3 orders and
 * basket is empty.
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

export default class InstantShopAd extends PureComponent {
  static propTypes = {
    basket: PropTypes.shape({
      numberOfItems: PropTypes.number.isRequired,
    }).isRequired,
    router: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    user: PropTypes.object.isRequired,
  };

  render() {
    const { basket, user, router } = this.props;

    if (basket.numberOfItems || !get(user, 'shoppingDetails.suggestedOrderAvailable')) {
      return null;
    }

    return (
      <button
        className="hd-instantShopAdSingleLarge"
        onClick={() => router.push('/webshop/displaySuggestedOrder.do')}
        type="button"
      >
        <b className="hd-instantShopAdSingleLarge__heading">Place an order in seconds</b>
        <span className="hd-instantShopAdSingleLarge__text">Try a suggested order based on your Favourites.</span>
      </button>
    );
  }
}
